import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { WaybillEquipmentMaterialItemModel } from '../../../store/models/waybill-equipments.model';
import { MeasurementUnitCodesEnum } from '../../../common/models';
import { MeasurementUnitCodesMap } from '../../../common/constants';

@Component({
  selector: 'ui-equipment-materials',
  templateUrl: './equipment-materials.component.html',
  styleUrls: ['./equipment-materials.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EquipmentMaterialsComponent {
  @Input() materials: WaybillEquipmentMaterialItemModel[] = [];
  @Input() volumeUnitCode: MeasurementUnitCodesEnum | null = null;
  @Input() weightUnitCode: MeasurementUnitCodesEnum | null = null;
  materialColumns: string[] = [
    'materialNumber',
    'materialDescription',
    'grossWeight',
    'netWeight',
    'volume',
    'quantity',
    'quantityUnitCode',
  ];
  protected readonly measurementUnitCodes = MeasurementUnitCodesMap;
}
